<template>
    <div>
        <div v-if="dossier" class="container">
            <!-- Explications -->
            <h3 id="top-feuillet">{{$t("Bareme.etape3.titre")}}</h3>
            <div class="row">
                <div class="col-md-12">
                    <div class="field field-name-body field-type-text-with-summary field-label-hidden">
                        <div class="field-items">
                            <div class="field-item even">
                                <p v-html="$t('Bareme.etape3.info')"> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Formulaire -->
            <section-panel-info :titre="$t('Bareme.etape3.panelInfo.panelTitre')">
                <p><strong>Année fiscale :</strong> {{dossier.periodeFiscale}}</p>
                <p><strong>Barème :</strong> {{dossier.bareme}}</p>
                <form role="form">
                    <h5>{{this.$t("Bareme.etape3.champs.titreContribuable", {annee: dossier.periodeFiscale})}}</h5>
                    <div class="row clearfix">
                        <div class="col-md-6 column">
                             <!--Revenu contribuable CHF-->
                            <section-revenu-mask v-model="revenuContribuable"
                                                 :nomChamp="'revenuContribuable'"
                                                 :submitted="submitted"
                                                 name="revenuContribuable"
                                                 :lbl-revenu='$t("Calculette.champs.revenuCHF")'
                                                 monnaie="CHF"
                                                 tooltip-titre='Bareme.etape3.tooltip.titre.revenuContribuableCHF'
                                                 tooltip-contenu='Bareme.etape3.tooltip.contenu.revenuContribuableCHF'>

                            </section-revenu-mask>
                        </div>
                        <div class="col-md-6 column">
                            <section-revenu-mask v-model="revenuContribuableEUR"
                                                 :nomChamp="'revenuContribuableEUR'"
                                                 :submitted="submitted"
                                                 name="revenuContribuableEUR"
                                                 :lbl-revenu='$t("Calculette.champs.revenuEUR")'
                                                 monnaie="EUR"
                                                 :options-contenu="{tauxChange: tauxChange, url: 'https://www.ge.ch/taux-donnees-fiscales'}"
                                                 tooltip-titre='Bareme.etape3.tooltip.titre.revenuContribuableEUR'
                                                 tooltip-contenu='Bareme.etape3.tooltip.contenu.revenuContribuableEUR'>

                            </section-revenu-mask>
                        </div>
                    </div>
                    <div class="row clearfix">
                        <div class="col-md-12 column">
                            <div class="form-group">
                                <div class="input-group">
                                    <span v-if="submitted && (!isRevenuContribuableSaisi)" class="text-danger">
                                        {{ $t('Bareme.etape3.validation.auMoinsUnRevenu')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5>{{this.$t("Bareme.etape3.champs.titreConjoint", {annee: dossier.periodeFiscale})}}</h5>
                    <div class="row clearfix">
                        <div class="col-md-6 column">
                            <section-revenu-mask v-model="revenuConjoint"
                                                 :nomChamp="'revenuConjoint'"
                                                 :submitted="submitted"
                                                 name="revenuConjoint"
                                                 v-validate='{ rules: { required: (revenuConjointEUR !== "") ? false : true, min_value:1}}'
                                                 :lbl-revenu='$t("Calculette.champs.revenuCHF")'
                                                 monnaie="CHF"
                                                 tooltip-titre='Bareme.etape3.tooltip.titre.revenuConjointCHF'
                                                 tooltip-contenu='Bareme.etape3.tooltip.contenu.revenuConjointCHF'>

                            </section-revenu-mask>
                        </div>
                        <div class="col-md-6 column">
                            <section-revenu-mask v-model="revenuConjointEUR"
                                                 :nomChamp="'revenuConjointEUR'"
                                                 :submitted="submitted"
                                                 name="revenuConjointEUR"
                                                 :lbl-revenu='$t("Calculette.champs.revenuEUR")'
                                                 monnaie="EUR"
                                                 :options-contenu="{tauxChange: tauxChange, url:'https://www.ge.ch/taux-donnees-fiscales'}"
                                                 tooltip-titre='Bareme.etape3.tooltip.titre.revenuContjoinEUR'
                                                 tooltip-contenu='Bareme.etape3.tooltip.contenu.revenuContjoinEUR'>

                            </section-revenu-mask>
                        </div>

                    </div>
                    <div class="row clearfix">
                        <div class="col-md-12 column">
                            <div class="form-group">
                                <div class="input-group">
                                    <span v-if="submitted && (!isRevenuConjointSaisi)" class="text-danger">
                                        {{ $t('Bareme.etape3.validation.auMoinsUnRevenu')}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <button class="btn btn-default" style="margin-right:5px;" @click="onRetour"
                        :title="$t('general.btnRetourTitle')">
                    {{this.$t("general.btnRetour")}}
                </button>
                <button class="btn btn-primary" style="margin-right:5px;" @click="onSubmit"
                        :title="$t('Bareme.etape3.buttons.calculerAide')">
                    {{this.$t("Bareme.etape3.buttons.calculer")}}
                </button>
            </section-panel-info>
        </div>
    </div>
</template>

<script>

import TooltipUtils from '@/utils/TooltipUtils';
import ProgressBarUtils from '@/utils/ProgressBarUtils';
import CalculetteDto from '@/models/CalculetteDto';
import ImpotSourceDto from '@/models/calculette/ImpotSourceDto';
import ImpotSourceRestApi from '@/services/ImpotSourceRestApi';
import TitreRestApi from '@/services/TitreRestApi';
import ContribuableIsDto from '@/models/bareme/ContribuableIsDto';
import SimulationDto from '@/models/SimulationDto';
import SectionRevenuMask from '../../commun/SectionRevenuMask.vue';
import SectionPanelInfo from '../../commun/SectionPanelInfo.vue';

const BigNumber = require('bignumber.js');

export default {
  name: 'bareme-etape-3',
  mixins: [TooltipUtils, ProgressBarUtils],
  components: { SectionRevenuMask, SectionPanelInfo },
  computed: {
    dossier() {
      return this.$store.getters['dossier/getDossier'];
    },
  },
  data() {
    return {
      revenuContribuable: '',
      revenuContribuableEUR: '',
      revenuConjoint: '',
      revenuConjointEUR: '',
      submitted: false,
      isRevenuContribuableSaisi: false,
      isRevenuConjointSaisi: false,
      tauxChange: '',
    };
  },
  created() {
    if (!this.dossier) {
      this.$router.push({ name: 'routePrelevementEtape1' });
    }
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.revenuContribuable = this.revenuContribuable.replace(/\D/g, '');
      this.revenuConjoint = this.revenuConjoint.replace(/\D/g, '');
      this.revenuContribuableEUR = this.revenuContribuableEUR.replace(/\D/g, '');
      this.revenuConjointEUR = this.revenuConjointEUR.replace(/\D/g, '');

      // Validation manuelle car IE11 n'est pas assez intelligent pour comprendre vee-validate
      if (!(Number(this.revenuContribuable) > 0 || Number(this.revenuContribuableEUR) > 0)) {
        this.isRevenuContribuableSaisi = false;
      } else {
        this.isRevenuContribuableSaisi = true;
      }

      if (!(Number(this.revenuConjoint) > 0 || Number(this.revenuConjointEUR) > 0)) {
        this.isRevenuConjointSaisi = false;
      } else {
        this.isRevenuConjointSaisi = true;
      }

      if (this.isRevenuContribuableSaisi && this.isRevenuConjointSaisi) {
        const simulation = this.buildSimulationDto();
        const reponseBackend = await new ImpotSourceRestApi().determinerBaremeAjuste(simulation);
        const resultat = this.mapReponseBackend(reponseBackend);
        const r = resultat;
        const d = this.dossier;
        this.$router.push({ name: 'routePrelevementEtape4', params: { resultat: r, dossier: d } });
      } else {
        // Scroll vers le prémier erreur du formulaire
        // this.$el.querySelector(`input[name=${this.$validator.errors.items[0].field}]`).closest('.form-group').scrollIntoView();
      }
    },
    buildSimulationDto() {
      const impotSourceDto = new ImpotSourceDto();
      impotSourceDto.annee = this.dossier.periodeFiscale;
      impotSourceDto.codeBareme = this.dossier.bareme;
      // impotSourceDto.revenuContribuable = (this.revenuContribuable ? new BigNumber(this.revenuContribuable).toFixed() : 0)
      //       + (this.revenuContribuableEUR ? (new BigNumber(this.revenuContribuableEUR) * Number(this.tauxChange)) : 0);

      impotSourceDto.revenuContribuable = (this.revenuContribuable ? Number(this.revenuContribuable) : 0)
            + (this.revenuContribuableEUR ? (Number(this.revenuContribuableEUR) * Number(this.tauxChange)) : 0);
      // const revContCHF = (this.revenuContribuable ? new BigNumber(this.revenuContribuable) : new BigNumber('0'));
      // const revContEUR = (this.revenuContribuableEUR ? (new BigNumber(this.revenuContribuableEUR).multipliedBy(new BigNumber(this.tauxChange))) : new BigNumber('0'));
      // impotSourceDto.revenuContribuable = revContCHF.plus(revContEUR).toString();
      impotSourceDto.revenuGlobal = Number(this.revenuContribuable) + Number(this.revenuConjoint);
      impotSourceDto.revenuConjoint = (this.revenuConjoint ? Number(this.revenuConjoint) : 0)
            + (this.revenuConjointEUR ? (Number(this.revenuConjointEUR) * Number(this.tauxChange)) : 0);

      const contribuableIsDto = new ContribuableIsDto();
      contribuableIsDto.frontalier = this.dossier.typeResident.value;
      contribuableIsDto.conjointRevenuOu = this.dossier.sourceRevenu.map(k => k.code);
      if (this.dossier.isConjointFonctionnaireInt) {
        contribuableIsDto.conjointFonctionnaireInternationale = this.dossier.isConjointFonctionnaireInt;
      }
      const simulation = new SimulationDto();
      simulation.impotSourceDto = impotSourceDto;
      simulation.contribuableIsDto = contribuableIsDto;
      return simulation;
    },
    mapReponseBackend(reponseBackend) {
      const resultat = new CalculetteDto();
      resultat.annee = this.dossier.periodeFiscale;
      resultat.isBaremeRectif = false;
      resultat.isBaremeAjuste = true;
      resultat.bareme = reponseBackend.bareme;
      resultat.codeBaremePrelevement = `Cr${reponseBackend.bareme.substr(1)}`;
      resultat.baremeAjuste = reponseBackend.baremeAjuste == null ? reponseBackend.bareme : reponseBackend.baremeAjuste;
      resultat.tauxALaBaisse = (Number(reponseBackend.tauxALaBaisse) * 100).toFixed(2);
      resultat.tauxALaHausse = (Number(reponseBackend.tauxALaHausse) * 100).toFixed(2);
      resultat.typeBaremeAjuste = reponseBackend.typeBaremeAjuste;

      resultat.tauxChange = this.tauxChange;

      resultat.revenuContribuable = reponseBackend.revenuContribuable;
      resultat.revenuContribuableCHF = this.revenuContribuable;
      resultat.revenuConjointCHF = this.revenuConjoint;

      if (Number(this.revenuContribuableEUR) > 0) {
        resultat.revenuContribuableEUR = this.revenuContribuableEUR;
      }
      if (Number(this.revenuConjointEUR) > 0) {
        resultat.revenuConjointEUR = this.revenuConjointEUR;
      }

      resultat.tauxContribuable = (Number(reponseBackend.tauxPrelevementContribuable) * 100).toFixed(2);
      resultat.montantImpotContribuable = new BigNumber(reponseBackend.montantPrelevementContribuable);

      resultat.revenuConjoint = new BigNumber(reponseBackend.revenuConjoint);
      resultat.tauxConjoint = (reponseBackend.tauxPrelevementConjoint * 100).toFixed(2);
      resultat.montantImpotConjoint = reponseBackend.montantPrelevementConjoint;

      resultat.montantImpotCouple = reponseBackend.totalPrelevementCouple;

      resultat.revenuUtilisePourLeTaux = reponseBackend.revenuPourTaux;
      resultat.revenuImpose = reponseBackend.revenuImpose;
      resultat.taux = (reponseBackend.taux * 100).toFixed(2);
      resultat.montantImpot = reponseBackend.montantImpot;

      resultat.isTaux = reponseBackend.pourLeTaux;

      resultat.solde = reponseBackend.bilan;
      return resultat;
    },
    onRetour(e) {
      e.preventDefault();
      this.$router.push({ name: 'routePrelevementEtape2' });
    },
    async validerForm() {
      const promiseArr = this.$children.map(child => child.$validator.validateAll());
      return Promise.all(promiseArr.map(validation => validation.then((v) => {
        this.$log.info(`Validation partie formulaire:${v}`);
        return v;
      })))
        .then((resultatValidation) => {
          this.$log.info(resultatValidation);
          return !resultatValidation.includes(false);
        })
        .catch(() => {
          // this.show_message_error_validation();
        });
    },
  },
  async mounted() {
    this.tauxChange = await new TitreRestApi().getTauxChange(this.dossier.periodeFiscale, 'EUR');
    this.initProgressBar(4, [this.$t('Bareme.progressBar.etape1'), this.$t('Bareme.progressBar.etape2'),
      this.$t('Bareme.progressBar.etape3'), this.$t('Bareme.progressBar.etape4')], 3, this.$t('Bareme.titre'));
  },
};
</script>

<style scoped>

</style>
